import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";

const CustomGridIconSVG = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const predefinedSizes = {
    small: { ...themeValue?.fontSmlSize?.size },
    medium: { ...themeValue?.fontMediumSize?.size },
    large: { ...themeValue?.fontLgSize?.size },
  };
  const { size, width, height } = props;
  const finalSize = predefinedSizes[size] || { width, height };
  return (
    <svg
      width={finalSize.width || "24"}
      height={finalSize.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
        fill="currentColor"
      />
      <path
        d="M22 9.25H2.03003C1.62003 9.25 1.28003 8.91 1.28003 8.5C1.28003 8.09 1.62003 7.75 2.03003 7.75H22C22.41 7.75 22.75 8.09 22.75 8.5C22.75 8.91 22.41 9.25 22 9.25Z"
        fill="currentColor"
      />
      <path
        d="M22 16.25H2.03003C1.62003 16.25 1.28003 15.91 1.28003 15.5C1.28003 15.09 1.62003 14.75 2.03003 14.75H22C22.41 14.75 22.75 15.09 22.75 15.5C22.75 15.91 22.41 16.25 22 16.25Z"
        fill="currentColor"
      />
      <path
        d="M8.51001 22.74C8.10001 22.74 7.76001 22.4 7.76001 21.99V2.01001C7.76001 1.60001 8.10001 1.26001 8.51001 1.26001C8.92001 1.26001 9.26001 1.60001 9.26001 2.01001V21.98C9.26001 22.4 8.93001 22.74 8.51001 22.74Z"
        fill="currentColor"
      />
    </svg>
  );
};
const CustomGridIcon = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const { size } = props;
  const predefinedSizes = {
    small: themeValue?.fontSmlSize,
    medium: themeValue?.fontMediumSize,
    large: themeValue?.fontLgSize,
  };
  return (
    <Icon
      component={CustomGridIconSVG}
      style={{
        // color: color || themeDefault?.info?.newConfig?.color,

        fontSize: predefinedSizes[size] || predefinedSizes.medium,
      }}
      {...props}
    />
  );
};

export default CustomGridIcon;
